import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettingsComp} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';


@Component({
  selector: 'app-header-setting',
  templateUrl: './header-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class HeaderSettingComponent implements OnInit {
  @Input() header: ILayoutSettingsComp;
  constructor(private cs: CommonService) { }

  ngOnInit() {
  }

  selectFile(el: any) {
    const input = el.target.files[0];
 
    const reader = new FileReader();
    reader.readAsDataURL(input);
    reader.onload = () => {
      this.header.logo = reader.result.toString();
      this.cs.uploadFile(input.name, reader.result.toString()).then(res => { this.header.logo = res, this.header.IsDefaultLogo = false });
    };
  }
}
